import { RotateCcw} from 'lucide-react';
import { useGlobalStates } from "./globalConstants";

export default function Header() {
    const { messages, setMessages, socket, setCompleted, setWrapUp } = useGlobalStates();

    const resetSession = () => {
        console.log("[DEBUG] Resetting Session");
        setMessages([]);
        setCompleted(false);
        setWrapUp(false);
        socket.emit("soft-reset");
    };

    return (
        <div className="bg-white border-b border-gray-200 px-6 py-4">
            <div className="max-w-8xl mx-auto">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <svg width="64" height="64" viewBox="0 0 288 173" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-16 w-16">
                        <ellipse cx="80.1102" cy="85.5599" rx="68" ry="67.5" transform="rotate(-10.7212 80.1102 85.5599)" fill="#82cdc9ff"/>
                        <circle cx="201.5" cy="86.4" r="66.5" transform="rotate(21.3298 201.5 86.4)" fill="#447FFF"/>
                        <circle cx="61.3759" cy="81.4445" r="9.03125" transform="rotate(-10.7212 61.3759 81.4445)" fill="white"/>
                        <circle cx="94.7827" cy="75.1195" r="9.03125" transform="rotate(-10.7212 94.7827 75.1195)" fill="white"/>
                        <rect x="58.0493" y="100.998" width="48.875" height="11.6875" rx="5.84375" transform="rotate(-10.7212 58.0493 100.998)" fill="white"/>
                        <circle cx="188.909" cy="72.4993" r="9.03125" transform="rotate(21.3298 188.909 72.4993)" fill="white"/>
                        <circle cx="220.58" cy="84.8663" r="9.03125" transform="rotate(21.3298 220.58 84.8663)" fill="white"/>
                        <rect x="175.712" y="87.3074" width="48.875" height="11.6875" rx="5.84375" transform="rotate(21.3298 175.712 87.3074)" fill="white"/>
                        </svg>
                        <div>
                        <h1 className="text-2xl font-bold text-gray-900">Couple Agents</h1>
                        <p className="text-sm text-gray-600">Couple Therapy Training</p>
                        </div>
                    </div>
                    <button
                        className="flex items-center space-x-2 px-4 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                        onClick={resetSession}
                    >
                        <RotateCcw className="h-4 w-4" />
                        <span>New Session</span>
                    </button>
                </div>
            </div>
        </div>
    )
}